<template>
  <v-dialog
    :max-width="maxWidth"
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Evolución</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row class="my-4 mx-1">
          <h3>Profesional: {{ evolucion.nomProfesional }}</h3>
        </v-row>
        <v-row class="my-2 mx-1">
          <h3>Fecha: {{ evolucion.fechaHoraString }}</h3>
        </v-row>
        <v-row
          v-if="$store.state.usuario.institucion.idInstitucion === 436"
          class="mb-2 mt-4 mx-1"
        >
          <h3>
            Es control de niño sano:
            {{ `${evolucion.controlNinoSano ? "Si" : "No"}` }}
          </h3>
        </v-row>
        <template v-if="!evolucion.usaPlantilla">
          <v-row class="mt-4 mx-1">
            <h3>Evolución:</h3>
          </v-row>
          <v-row class="ml-1">
            <div v-html="textoFormateado" class="texto-evolucion"></div>
          </v-row>
        </template>
        <template v-else>
          <div class="mt-4">
            <template v-for="([key, value], index) in camposJson">
              <v-row v-if="value" class="mt-2 mx-1" :key="index">
                <h3>{{ camelToLabel(key) }}: {{ value }}</h3>
              </v-row>
            </template>
          </div>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="warning" @click.stop="seleccionImprimir">Imprimir</v-btn>
        <v-btn color="error" @click.stop="show = false">Salir</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style scoped>
.multi-line {
  white-space: pre-line;
}
.v-dialog__content {
  align-items: left;
  justify-content: left;
}
.texto-evolucion {
  font-size: 16px;
  font-weight: 500;
  color: #000;
  margin-top: 1.5rem;
  line-height: 1.5;
  white-space: pre-line;
}
</style>
<script>
import axios from "../../axios-auth.js";
import jsPDF from "jspdf";
import moment from "moment";
import { getEdad } from "../../utils/utils.js";

export default {
  data: (vm) => ({
    maxWidth: "100%",
    base64: "",
  }),
  props: ["visible", "evolucion", "paciente"],
  computed: {
    show: {
      get() {
        if (this.$store.state.videollamada == true) this.maxWidth = "68%";
        else this.maxWidth = "100%";

        if (this.visible) this.getLogoUrl();
        return this.visible;
      },
      set(value) {
        if (!value) {
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
    camposJson() {
      return this.evolucion.evolucionJson
        ? Object.entries(JSON.parse(this.evolucion.evolucionJson))
        : [];
    },
    textoFormateado() {
      const texto = this.evolucion?.texto || "";
      const pareceHTML = /<\/?[a-z][\s\S]*>/i.test(texto);
      return pareceHTML ? texto : texto.replace(/\n/g, "<br>");
    },
  },
  methods: {
    seleccionImprimir() {
      if (this.evolucion.usaPlantilla) {
        this.imprimirPlantilla();
      } else {
        this.imprimir();
      }
    },
    camelToLabel(str) {
      return str
        .replace(/([A-Z])/g, " $1") // agrega espacio antes de mayúsculas
        .replace(/^./, (s) => s.toUpperCase()); // capitaliza la primera letra
    },
    getLogoUrl() {
      let self = this;

      axios
        .get("/HistoriaClinica/GetLogo?", {
          params: {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
          },
        })
        .then((response) => {
          self.base64 = response.data;
        })
        .catch((error) => {});
    },
    esHTML(text) {
      return /<\/?[a-z][\s\S]*>/i.test(text);
    },
    sanitizeToPlainText(html) {
      if (!html) return "";

      // Crear un elemento temporal para usar el parser del navegador
      const temp = document.createElement("div");
      temp.innerHTML = html;

      // Reemplazar etiquetas de bloque con saltos de línea
      const blockTags = ["p", "div", "br", "li", "tr"];
      blockTags.forEach((tag) => {
        const elements = temp.getElementsByTagName(tag);
        for (let el of elements) {
          // Agregar salto de línea después de cada elemento de bloque
          el.insertAdjacentText("afterend", "\n");
        }
      });

      // Obtener solo el texto visible
      let text = temp.textContent || temp.innerText || "";

      // Limpiar múltiples saltos de línea o espacios
      text = text.replace(/\n\s*\n+/g, "\n").trim();

      return text;
    },
    imprimir() {
      const doc = new jsPDF();

      doc.setProperties({
        title: "Evolucion",
      });

      const nombreInstitucion =
        this.$store.state.usuario.institucion.nombreInstitucion
          .toString()
          .trim();

      doc.setFontSize(12);
      doc.text(nombreInstitucion, 13, 10);

      doc.setFontSize(10);
      doc.text(
        "Paciente: " + this.paciente.apellidos + " " + this.paciente.nombres,
        13,
        25,
      );
      doc.text("D.N.I.: " + this.paciente.dni, 13, 30);
      const fecha = this.paciente.fechaNac
        ? moment(
            this.paciente.fechaNac,
            ["DD/MM/YYYY", "YYYY-MM-DD"],
            true,
          ).format("DD/MM/YYYY")
        : "";
      doc.text("Fecha de Nac.: " + fecha, 13, 35);
      doc.text("Edad: " + getEdad(fecha), 13, 40);

      if (this.base64 != null && this.base64 !== "") {
        doc.addImage(this.base64, 140, 5, 60, 20);
      }

      doc.setFontSize(16);
      doc.text("Evolución", doc.internal.pageSize.getWidth() / 2, 50, {
        align: "center",
      });

      doc.line(93, 51, 117, 51);
      doc.line(13, 60, 200, 60);

      doc.setFontSize(13);
      doc.text(
        "Profesional: " +
          this.evolucion.matricula +
          " - " +
          this.evolucion.nomProfesional,
        13,
        67,
      );
      doc.text("Fecha: " + this.evolucion.fechaHoraString, 13, 73);
      doc.line(13, 76, 200, 76);

      // Texto de la evolución
      doc.setFontSize(12);
      const maxWidth = 185; // ancho disponible (200 - márgenes)
      let y = 83;

      const evolucionSanitizada = !this.esHTML(this.evolucion.texto)
        ? this.evolucion.texto
        : this.sanitizeToPlainText(this.evolucion.texto);

      // Primero dividimos en párrafos (enter)
      const parrafos = evolucionSanitizada.split(/\r\n|\r|\n/);

      parrafos.forEach((parrafo) => {
        // Ajustamos cada párrafo al ancho disponible
        const lineas = doc.splitTextToSize(parrafo, maxWidth);

        lineas.forEach((linea) => {
          doc.text(linea, 13, y);
          y += 5;

          if (y > 290) {
            doc.addPage();
            y = 20;
          }
        });

        // salto extra después de cada párrafo
        y += 2;
        if (y > 290) {
          doc.addPage();
          y = 20;
        }
      });

      // Abrir en nueva pestaña
      window.open(doc.output("bloburl"), "_blank");
      // o guardar: doc.save("evolucion.pdf");
    },
    imprimirPlantilla() {
      var doc = new jsPDF();

      doc.setProperties({
        title: "Evolucion",
      });
      //doc.text('Listado de Turnos',20,10);
      var nombreInstitucion =
        this.$store.state.usuario.institucion.nombreInstitucion
          .toString()
          .trim();

      doc.setFontSize(12);
      doc.text(nombreInstitucion, 13, 10);
      doc.setFontSize(10);
      doc.text(
        "Paciente: " + this.paciente.apellidos + " " + this.paciente.nombres,
        13,
        25,
      );

      doc.text("D.N.I.: " + this.paciente.dni, 13, 30);
      doc.text("Feche de Nac.: " + this.paciente.fechaNac, 13, 35);
      doc.text("Edad: " + this.paciente.edad, 13, 40);
      doc.setFontSize(16);

      if (this.base64 != null && this.base64 != "")
        doc.addImage(this.base64, 140, 5, 60, 20);

      doc.text("Evolución", doc.internal.pageSize.getWidth() / 2, 50, {
        align: "center",
      });
      doc.line(93, 51, 117, 51);
      doc.line(13, 60, 200, 60);
      doc.setFontSize(13);
      doc.text(
        "Profesional: " +
          this.evolucion.matricula +
          " - " +
          this.evolucion.nomProfesional,
        13,
        67,
      );
      doc.text("Fecha: " + this.evolucion.fechaHoraString, 13, 73);
      doc.line(13, 76, 200, 76);
      doc.setFontSize(12);

      let y = 83;
      for (var j = 0; j < this.camposJson.length; j++) {
        if (!this.camposJson[j][1]) {
          continue;
        }
        y = y + 5;
        if (y > 290) {
          y = 20;
          doc.addPage();
        }
        const textoLabel =
          this.camelToLabel(this.camposJson[j][0]) +
          ": " +
          this.camposJson[j][1];
        var textoSplit = textoLabel.split(/\r\n|\r|\n/);
        for (var i = 0; i < textoSplit.length; i++) {
          if (textoSplit[i].length < 85) {
            doc.text(textoSplit[i], 13, y);
          } else {
            var lineSplit = textoSplit[i].split(" ");
            var linePrint = "";
            var lineTemp = "";
            for (var j = 0; j < lineSplit.length; j++) {
              if (linePrint.length >= 85) {
                if (j == lineSplit.length - 1)
                  doc.text(lineSplit[j], 13, y + 5);

                lineTemp = linePrint + lineSplit[j];
                if (lineTemp.length < 85) {
                  doc.text(lineTemp, 13, y);
                  linePrint = "";
                } else {
                  doc.text(linePrint, 13, y);
                  linePrint = lineSplit[j] + " ";
                }
                y = y + 5;

                if (y > 290) {
                  y = 20;
                  doc.addPage();
                }
              } else {
                linePrint = linePrint + lineSplit[j] + " ";
                if (j == lineSplit.length - 1) {
                  doc.text(linePrint, 13, y);
                  if (y > 290) {
                    y = 20;
                    doc.addPage();
                  }
                }
              }
            }
          }
          y = y + 5;
          if (y > 290) {
            y = 20;
            doc.addPage();
          }
          //comentario version 3
        }
      }
      // var textoSplit = this.evolucion.texto.split(/\r\n|\r|\n/);
      // let y = 83;
      // for (var i = 0; i < textoSplit.length; i++) {
      //   if (textoSplit[i].length < 85) {
      //     doc.text(textoSplit[i], 13, y);
      //   } else {
      //     var lineSplit = textoSplit[i].split(" ");
      //     var linePrint = "";
      //     var lineTemp = "";
      //     for (var j = 0; j < lineSplit.length; j++) {
      //       if (linePrint.length >= 85) {
      //         if (j == lineSplit.length - 1) doc.text(lineSplit[j], 13, y + 5);

      //         lineTemp = linePrint + lineSplit[j];
      //         if (lineTemp.length < 85) {
      //           doc.text(lineTemp, 13, y);
      //           linePrint = "";
      //         } else {
      //           doc.text(linePrint, 13, y);
      //           linePrint = lineSplit[j] + " ";
      //         }
      //         y = y + 5;

      //         if (y > 290) {
      //           y = 20;
      //           doc.addPage();
      //         }
      //       } else {
      //         linePrint = linePrint + lineSplit[j] + " ";
      //         if (j == lineSplit.length - 1) {
      //           doc.text(linePrint, 13, y);
      //           if (y > 290) {
      //             y = 20;
      //             doc.addPage();
      //           }
      //         }
      //       }
      //     }
      //   }
      //   y = y + 5;
      //   if (y > 290) {
      //     y = 20;
      //     doc.addPage();
      //   }
      //   //comentario version 3
      // }
      window.open(doc.output("bloburl"), "_blank");

      //doc.save('turnos.pdf');
    },
  },
};
</script>
